/** True when `id` looks like a non-empty RFC 4122 GUID string (used for API analysis/run ids). */
export function isServerBackedAnalysisId(id: unknown): boolean {
  if (id == null || typeof id !== 'string') return false;
  return /^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(id.trim());
}
